import { gql, QueryResult } from '@apollo/client';
import get from 'lodash.get';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CheckIcon, Description, FlexWrapper, Title } from './styled-components';
import { Query } from '@apollo/client/react/components';
import checkmark from 'assets/icons/medication-checkmark.svg';
import { Button } from 'components/v2/Buttons/Button/Button';
import styled from 'styled-components';
import { pageUrl } from 'utilities/pageUrl';

type TodoResult = QueryResult<{
  patientTodos: {
    id: string;
    todoId: string;
    title: string;
    linkUrl: string;
    description: string;
    completed: string;
    order: unknown;
  };
}>;

const TODOS = gql`
  query patientTodos {
    patientTodos {
      id
      todoId
      title: name
      linkUrl
      buttonText
      description
      completed
      order
    }
  }
`;

export const ReviewTodos = () => {
  const navigate = useNavigate();

  return (
    <Query query={TODOS}>
      {({ data, error, loading }: TodoResult) => {
        if (loading || error || !data) {
          return null;
        }
        const patientTodos = get(data, 'patientTodos', []);
        // @ts-ignore
        const completed = patientTodos.length === 0;

        return (
          <>
            <Title>
              Review to-dos on your dashboard
              {completed && <CheckIcon src={checkmark} alt="check" />}
            </Title>
            <FlexWrapper>
              <div>
                <Description>
                  Your care team has selected the next steps necessary for your care plan. These are
                  ready for your review on your dashboard.
                </Description>
              </div>
              {!completed && (
                <ButtonStyled
                  label="View dashboard"
                  onClick={() => navigate(pageUrl.dashboard())}
                />
              )}
            </FlexWrapper>
          </>
        );
      }}
    </Query>
  );
};

const ButtonStyled = styled(Button).attrs({ category: 'secondary', size: 'md' })`
  min-width: fit-content;
  height: fit-content;
  width: fit-content;
  white-space: nowrap;
`;
